const modalButtons = document.getElementsByClassName('js-modal-button');
const modalBack = document.getElementsByClassName('js-modal-back')[0];
const modalClose = document.getElementsByClassName('js-modal-close');

if (modalButtons) {
  Array.from(modalButtons).forEach(button => {
    button.addEventListener('click', () => {
      let index = button.dataset.state;
      index = index.replace('staffId', '');
      const modalcontent = document.querySelector('.js-modal-content[data-state="staffId' + index + '"]');

      if (modalcontent) {
        modalcontent.classList.add('is-active');
        modalBack.classList.add('is-active');
      }
    });
  })
}

if (modalBack) {
  Array.from(modalClose).forEach(close => {
    close.addEventListener('click', () => {
      const activeContent = document.querySelector('.js-modal-content.is-active');
      activeContent.classList.remove('is-active');
      modalBack.classList.remove('is-active');
    })
  })
  modalBack.addEventListener('click', () => {
    const activeContent = document.querySelector('.js-modal-content.is-active');
    activeContent.classList.remove('is-active');
    modalBack.classList.remove('is-active');
  })
}